// extracted by mini-css-extract-plugin
export default {"border":"border--GD123","menu-item":"menu-item--WShAz","popper":"popper--jrEFu","not-bold":"not-bold--Y1yJr","menu":"menu--j7K4X"};